module.exports = __webpack_public_path__ + "static/media/sea-road-white.15da2c6d.png";